import {RouteConfig} from "vue-router";

/**
 * An array of route configuration objects
 * @type {RouteConfig[]}
 *  >> webpackChunkName: "contact-manager" <<
 * where ever we mention this, it will group all components in one group.
 */
const ContactManagerRoutes = [
    {
        path: "contact",
        // name: 'contact-manager',
        component: () => import(/* webpackChunkName: "contact-manager" */'./ContactManager.vue'),
        children: [
            {
                path: "",
                name: 'contacts.index',
                component: () => import(/* webpackChunkName: "contact-manager" */'./pages/ContactManagerIndex.vue'),
                meta: { topbar: true, project_title: true, sub_sidebar:"ContactsSubSidebar" }
            },
        ]
    }
];

export default ContactManagerRoutes;